module.exports = __webpack_public_path__ + "media/images/lock-364671dba8794601d7aea1b46d06f408.svg";